import  { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import Button from 'src/componentes/button';
import Panel from 'src/componentes/panel';
import PlanoContigenciaListView from 'src/paginas/gestao-risco/plano-contigencia/PlanoContigenciaListView';
import Dialog from 'src/componentes/dialog';

const PlanosContingenciaVinculadosBuscarView = ({
  model,
  requestChange,
  ...rest
}) => {
  const ref = useRef();
  const intl = useIntl();
  const [selecteds, setSelecteds] = useState([]);

  const onSelect = (newList) => {
    setSelecteds(newList);
  };

  const handleCancelClick = () => {
    ref.current.close();
  };

  const handleOkClick = () => {
    requestChange && requestChange(selecteds);
    handleCancelClick();
  };

  const actions = [
    <Button onClick={handleCancelClick} color="secondary">
      {intl.formatMessage({ id: 'label.cancelar' })}
    </Button>,
    <Button
      className="ml-2"
      type="primary"
      onClick={handleOkClick}
      htmlType="submit"
    >
      {intl.formatMessage({ id: 'label.salvar' })}
    </Button>,
  ];
  
  return (
    <Dialog
      {...rest}
      ref={ref}
      width="80%"
      height="80%"
      actions={actions}
      padContent
      onRequestClose={handleCancelClick}
    >
      <Panel
        header={intl.formatMessage({ id: 'labelPlanosContingenciaVinculados' })}
      >
        <PlanoContigenciaListView
          openLastFilter={false}
          select
          multiple
          isDisabled={true}
          onSelect={onSelect}
          selectedItems={model}
        />
      </Panel>
    </Dialog>
  );
};

export default PlanosContingenciaVinculadosBuscarView;
